import styled from "styled-components";
export const RootContainer = styled.div`
	position: relative;
	margin: 0;
	/* padding: 20px 16px; */
	/* .ant-table-wrapper {
    margin: 82px 16px 24px 16px;
  } */
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const OuterDiv = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 15px 30px;
	background-color: #0e1017;
	border: 1px solid #212224;
`;

export const InfoText = styled.span`
	color: ${(props) => (props.isName !== true ? "#686B6E" : "#F9F9F9")};
	font-size: 14px;
	line-height: 24px;
	font-weight: ${(props) => (props.isName === true ? "600" : "200")};
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
`;

export const IndexNumber = styled.div`
	color: #f9f9f9;
	display: flex;
	gap: 7px;
`;

export const Number = styled.div`
	margin-top: 2.7px;
	font-weight: 200;
	font-size: 14px;
`;

export const TitleWrapper = styled.div`
	background-color: #161719;
	height: 76px;
	margin-bottom: 24px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: 3px 0;
`;

export const Title = styled.p`
	font-weight: 200;
	font-size: 14px;
	line-height: 17.5px;
	color: #ffffff;
`;

export const SubTitle = styled.p`
	font-size: 14px;
	font-weight: 500;
	line-height: 17.5px;
	color: #ffb829;
`;

export const Top = styled.p`
	padding: 25px 16px 0px;
`;
